import { IDeleteDiarioObraParalisacoesUseCase } from "../../../presentation/useCases/delete/delete_diario_obras_paralisacoes_use_case";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";

// DeleteDiarioObraParalisacoesUseCase

export class DeleteDiarioObraParalisacoesUseCase implements IDeleteDiarioObraParalisacoesUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {}

  async deleteDiarioObraParalisacoes(IdDiarioObras: number, IdDiarioObrasParalisacoes: number): Promise<void> {
    await this.repository.deleteDiarioObraParalisacoes(IdDiarioObras, IdDiarioObrasParalisacoes);
  }
}
